import { API_ROOT_URL } from '@/lib/constants/api';
import { apiFetch } from '@/lib/utils/apiFetch';
import type {
  FileDetailEnvelope,
  FileListResponse,
  FileStatItem,
  ReplaceFilePayload,
  ReplaceFileResponse,
} from './types';

export async function fetchFilesList(qs: string): Promise<FileListResponse> {
  return apiFetch<FileListResponse>(
    `/api/cascade-tracing/documents/my-documents?${qs}`,
    {},
    API_ROOT_URL,
  );
}

export async function fetchFileDetail(
  documentId: string,
): Promise<FileDetailEnvelope> {
  return apiFetch<FileDetailEnvelope>(
    `/api/cascade-tracing/documents/${encodeURIComponent(documentId)}/purchase-order`,
    {},
    API_ROOT_URL,
  );
}

/** The statistics come under the standard `{ data }` envelope, unwrapped here. */
export async function fetchFileStatistics(): Promise<FileStatItem[]> {
  const { data } = await apiFetch<{ data: FileStatItem[] }>(
    '/api/cascade-tracing/documents/statistics',
    {},
    API_ROOT_URL,
  );
  return data;
}

export async function deleteFiles(ids: string[]): Promise<void> {
  return apiFetch<void>(
    '/api/cascade-tracing/documents',
    { method: 'DELETE', body: JSON.stringify({ ids }) },
    API_ROOT_URL,
  );
}

export async function replaceFile(
  payload: ReplaceFilePayload,
): Promise<ReplaceFileResponse> {
  return apiFetch<ReplaceFileResponse>(
    '/api/cascade-tracing/documents/replace',
    { method: 'POST', body: JSON.stringify(payload) },
    API_ROOT_URL,
  );
}
